import { render, staticRenderFns } from "./AiRuleManage.vue?vue&type=template&id=0c71d70c&scoped=true&"
import script from "./AiRuleManage.vue?vue&type=script&lang=js&"
export * from "./AiRuleManage.vue?vue&type=script&lang=js&"
import style0 from "./AiRuleManage.vue?vue&type=style&index=0&id=0c71d70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71d70c",
  null
  
)

export default component.exports